import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/pagination";
import creative1 from "../../../../assets/images/live_creative1.png";
import creative2 from "../../../../assets/images/live_creative2.png";

type ImageItem = {
  id: number;
  src: string;
  title: string;
  tags: string[];
  orientation: "landscape" | "portrait";
};

const images: ImageItem[] = [
  {
    id: 1,
    src: creative1,
    title: "Landscape 1",
    tags: ["Mumbai", "Main door", "Screen 1"],
    orientation: "landscape",
  },
  {
    id: 2,
    src: creative2,
    title: "Swiggy-instamart.png",
    tags: ["Delhi", "Entrance", "Screen 2"],
    orientation: "portrait",
  },
  {
    id: 3,
    src: creative1,
    title: "Landscape 2",
    tags: ["Bangalore", "Exit", "Screen 3"],
    orientation: "landscape",
  },
  {
    id: 4,
    src: creative2,
    title: "Portrait 2",
    tags: ["Chennai", "Lift", "Screen 4"],
    orientation: "portrait",
  },
  {
    id: 5,
    src: creative1,
    title: "Landscape 3",
    tags: ["Kolkata", "Lobby", "Screen 5"],
    orientation: "landscape",
  },
  {
    id: 6,
    src: creative2,
    title: "Portrait 3",
    tags: ["Hyderabad", "Parking", "Screen 6"],
    orientation: "portrait",
  },
];

const ImageCarousel: React.FC = () => {
  return (
    <div className="w-full max-w-screen-full mx-auto pl-4 py-1">
      <h2 className="text-sm md:text-sm xl:text-lg 2xl:text-xl 3xl:text-2xl whitespace-nowrap  mb-4">
        Live creatives
      </h2>
      <Swiper
        spaceBetween={16}
        slidesPerView="auto"
        loop
        autoplay={{ delay: 3000 }}
        pagination={{
          el: ".custom-swiper-pagination",
          clickable: true,
          renderBullet: (index: number, className: string) =>
            `<span class="${className}"></span>`,
        }}
        modules={[Autoplay, Pagination]}
      >
        {images.map((img) => (
          <SwiperSlide key={img.id} className="!w-auto flex-shrink-0">
            <div
              className={`relative overflow-hidden rounded-2xl shadow ${
                img.orientation === "portrait"
                  ? "w-[140px] sm:w-[150px] md:w-[160px] lg:w-[160px] 2xl:w-[180px] 3xl:w-[234px]"
                  : "w-[240px] sm:w-[260px] md:w-[280px] lg:w-[290px] 2xl:w-[320px] 3xl:w-[482px]"
              } h-[180px] sm:h-[200px] md:h-[220px] lg:h-[230px] 2xl:h-[250px] 3xl:h-[340px]`}
            >
              {/* Image */}
              <img
                src={img.src}
                alt={img.title}
                className="w-full h-full object-cover"
              />

              {/* Gradient overlay at bottom */}
              <div className="absolute bottom-0 left-0 right-0 h-[60px] bg-gradient-to-t from-black/70 to-transparent pointer-events-none" />

              {/* Title and Tags moved up */}
              <div
                className="
                  absolute 
                  bottom-[14px] left-[4px] right-[8px] 
                  sm:bottom-[20px] sm:left-[8px]
                  md:bottom-[28px] md:left-[12px]
                  lg:bottom-[36px] lg:left-[14px]
                  xl:bottom-[42px] xl:left-[16px]
                  2xl:bottom-[48px] 2xl:left-[16px]
                  3xl:bottom-[60px] 3xl:left-[20px]

                  z-10
                "
              >
                <div className="relative group">
                  <h2 className="text-white font-semibold text-lg 2xl:text-xl 3xl:text-2xl truncate group-hover:underline cursor-pointer">
                    {img.title}
                  </h2>
                  <div className="absolute bottom-full left-0 mb-1 w-max max-w-[200px] bg-[#EDEDED] text-black text-xs 2xl:text-sm 3xl:text-base px-2 py-1 rounded shadow-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200 z-20 pointer-events-none">
                    {img.title}
                  </div>
                </div>

                <div className="flex flex-wrap gap-[6.07px] mt-1">
                  {img.tags.map((tag, i) => (
                    <span
                      key={i}
                      className="bg-[#EDEDED] text-[10px] 2xl:text-[12px] 3xl:text-[14px] text-black px-[7.29px] py-[3.64px] rounded-[4.68px]"
                    >
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {/* Dot pagination below carousel */}
      <div className="custom-swiper-pagination mt-[15px] flex justify-center"></div>
    </div>
  );
};

export default ImageCarousel;
